/* import __COLOCATED_TEMPLATE__ from './impact-over-time-cta-link.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();